var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pqvbgqoe8a",
    d: "M14.065.855c.46.206.666.742.461 1.202-.204.46-.744.664-1.2.461-3.291-1.467-7.22-.578-9.557 2.16-2.338 2.736-2.604 6.756-.645 9.776 1.96 3.02 5.74 4.416 9.19 3.396 3.452-1.02 5.865-4.248 5.867-7.847v-.838c0-.502.407-.91.91-.91.501 0 .909.408.909.91v.838c-.003 4.4-2.951 8.345-7.17 9.592-.924.273-1.867.405-2.802.405-3.334 0-6.56-1.672-8.43-4.555-2.395-3.692-2.07-8.606.788-11.95C5.244.151 10.048-.936 14.065.854zm5.626 1.323c.391.371.391.974.001 1.346l-10 9.534c-.188.179-.442.279-.708.279-.265 0-.52-.1-.707-.28l-3-2.856c-.39-.373-.39-.975 0-1.347.391-.372 1.023-.372 1.414 0l2.293 2.183 9.292-8.858c.391-.374 1.025-.373 1.415-.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-713.000000, -556.000000) translate(302.000000, 403.000000) translate(411.000000, 152.999787)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "suqfwsgagb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pqvbgqoe8a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#323232",
    xlinkHref: "#pqvbgqoe8a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#suqfwsgagb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#359EAD",
    d: "M0 0H20V20H0z",
    transform: "translate(0.000000, -0.095025)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.2552e42f620610197a3cd379854f56ad.svg";
export { ForwardRef as ReactComponent };